import { useEffect, useRef, useState } from 'react';

// Smoothly tweens to `target` whenever it changes (ease-out cubic)
export const useAnimatedNumber = (target, duration = 600) => {
  const [value, setValue] = useState(target);
  const from = useRef(target);
  const raf = useRef(0);
  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) { setValue(target); from.current = target; return undefined; }
    const start = performance.now();
    const begin = from.current;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const v = begin + (target - begin) * (1 - Math.pow(1 - t, 3));
      from.current = v;
      setValue(v);
      if (t < 1) raf.current = requestAnimationFrame(tick);
    };
    cancelAnimationFrame(raf.current);
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration]);
  return value;
};
